import React from 'react';
import './Loader.css';

const Loader = () => {
  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
      background: 'rgba(255, 255, 255, 0.8)', display: 'flex',
      justifyContent: 'center', alignItems: 'center', zIndex: 9999
    }}>
      <div className="spinner"></div>
    </div>
  );
};

export default Loader;